import { SubscriptionPlanPriceResponseDTO } from '@core/api/dtos/response/accounts/subscriptionPlanPrice'
import { SubscriptionPlanPrice } from '@core/api/entities/account/subscriptionPlanPrice'

export class SubscriptionPlanPriceMapper {
	static toEntity(
		dto: SubscriptionPlanPriceResponseDTO
	): SubscriptionPlanPrice {
		return SubscriptionPlanPrice.create({
			planId: dto.plan_id,
			productId: dto.product_id,
			currency: dto.currency,
			price: dto.price,
		})
	}

	static toEntities(
		dtos: SubscriptionPlanPriceResponseDTO[]
	): SubscriptionPlanPrice[] {
		return dtos.map(this.toEntity)
	}
}
